import { ProductInterface } from '@pylot-data/fwrdschema'
import { OpenGraphImages } from 'next-seo/lib/types'
import { PylotFrontendConfig } from 'config'
import { fastlyUrl } from '.'
import { getFirstNotEmpty } from '@corratech/pylot-utils'

export const getProductImages = (
    product: ProductInterface,
    config: PylotFrontendConfig
): OpenGraphImages[] => {
    const imageList = product.media_gallery ?? []
    const { count, width, placeholder } = config.seo.product.image
    const images: OpenGraphImages[] = []
    imageList.slice(0, count).forEach((item) => {
        if (!item?.url) {
            return
        }
        images.push({
            url: fastlyUrl(item.url, width),
            alt: getFirstNotEmpty([item?.label, product?.name]),
            width
        })
    })
    if (images.length === 0 && placeholder) {
        images.push({
            url: fastlyUrl(placeholder, width),
            alt: String(product?.name),
            width
        })
    }
    return images
}
